import type { SupportingMethod } from '../types.js';

export const donchianBreakout: SupportingMethod = ({ candles, direction }) => {
  const period = 20;
  if (candles.length < period + 5 || direction === 'neutral') {
    return { id: 'TA-016', name: 'Donchian breakout', status: 'experimental', authority: 1, rawSignal: 0, contribution: 0, direction, finding: 'Insufficient candle history or no Core direction.', dataSufficient: false, sampleSize: candles.length };
  }
  const latest = candles.at(-1)!;
  const lookback = candles.slice(-(period + 1), -1);
  const upper = Math.max(...lookback.map((c) => c.high));
  const lower = Math.min(...lookback.map((c) => c.low));
  const breakout = direction === 'long' ? latest.close > upper : latest.close < lower;
  const penetration = direction === 'long' ? (latest.close - upper) / upper : (lower - latest.close) / lower;
  const aligned = breakout && penetration >= 0.001;
  return {
    id: 'TA-016', name: 'Donchian breakout', status: 'experimental', authority: 1, rawSignal: aligned ? 1 : 0, contribution: aligned ? 1 : 0, direction,
    finding: aligned ? `Price closed ${direction === 'long' ? 'above' : 'below'} the prior ${period}-candle Donchian boundary.` : `No qualifying ${period}-candle Donchian breakout aligned with the Core direction.`,
    dataSufficient: true, sampleSize: candles.length,
  };
};
